import styled from "styled-components";

export const ContainerModalOrdenacao = styled.div`
  display: flex;
  flex-direction: column;
  padding: 3rem 5rem;
  gap: 2rem;
  background-color: transparent;

  .modal-header1 {
    text-align: center;
    padding-bottom: 3rem;
  }

  .categorias-list {
    display: flex;
    flex-direction: column;
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
    position: relative;

    .linha {
      border-bottom: 1px solid ${(props) => props.theme.colors.elements};
    }

    .sortable-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 1rem;
      padding: 0.5rem;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: ${(props) => props.theme.colors.elements}20;
      }

      &.dragging {
        background-color: ${(props) => props.theme.colors.elements}40;
        border: 2px solid ${(props) => props.theme.colors.primary};
        border-radius: 8px;
      }

      .drag-handle {
        cursor: grab;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0.5rem;
        border-radius: 4px;
        transition: background-color 0.2s ease;
        touch-action: none;

        &:hover {
          background-color: ${(props) => props.theme.colors.elements};
        }

        &:active {
          cursor: grabbing;
        }
      }

      .categoria-nome {
        color: ${(props) => props.theme.colors.tertiary};
        text-align: start;
      }
    }
  }

  .botoes {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 3rem;

    .cancelar {
      color: ${(props) => props.theme.colors.tertiary};
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      svg {
        fill: ${(props) => props.theme.colors.tertiary};
        transform: rotate(90deg);
      }
    }

    .disabled {
      opacity: 0.7 !important;
    }
  }
`;
